import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageBerita() {
  const [list, setList] = useState([]);
  const ref = collection(db, "berita");

  /* ================= FETCH ================= */
  const fetchData = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    data.sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    setList(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= CLOUDINARY ================= */
  const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      data
    );

    return res.data.secure_url;
  };

  /* ================= TAMBAH ================= */
  const handleAdd = async () => {
    const { value: form } = await Swal.fire({
      title: "Tambah Berita",
      html: `
        <input id="judul" class="swal2-input" placeholder="Judul Berita">
        <textarea id="deskripsi" class="swal2-textarea" placeholder="Deskripsi"></textarea>
        <input id="tanggal" type="date" class="swal2-input">
        <input id="gambarUrl" class="swal2-input" placeholder="URL Gambar (opsional)">
        <input id="gambarFile" type="file" class="swal2-file">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Simpan",
      preConfirm: () => {
        return {
          judul: document.getElementById("judul").value,
          deskripsi: document.getElementById("deskripsi").value,
          tanggal: document.getElementById("tanggal").value,
          gambarUrl: document.getElementById("gambarUrl").value,
          gambarFile: document.getElementById("gambarFile").files[0],
        };
      },
    });

    if (!form || !form.judul || !form.deskripsi) {
      return Swal.fire("Oops!", "Judul & deskripsi wajib diisi", "warning");
    }

    let finalImage = form.gambarUrl;
    if (form.gambarFile) {
      finalImage = await uploadToCloudinary(form.gambarFile);
    }

    await addDoc(ref, {
      judul: form.judul,
      deskripsi: form.deskripsi,
      tanggal: form.tanggal || new Date().toISOString(),
      gambar: finalImage || "",
    });

    Swal.fire("Berhasil!", "Berita ditambahkan", "success");
    fetchData();
  };

  /* ================= EDIT ================= */
  const handleEdit = async (item) => {
    const { value: form } = await Swal.fire({
      title: "Edit Berita",
      html: `
        <input id="judul" class="swal2-input" value="${item.judul}">
        <textarea id="deskripsi" class="swal2-textarea">${item.deskripsi}</textarea>
        <input id="tanggal" type="date" class="swal2-input" value="${
          item.tanggal?.split("T")[0] || ""
        }">
        <input id="gambarUrl" class="swal2-input" value="${
          item.gambar || ""
        }" placeholder="URL Gambar">
        <input id="gambarFile" type="file" class="swal2-file">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Update",
      preConfirm: () => {
        return {
          judul: document.getElementById("judul").value,
          deskripsi: document.getElementById("deskripsi").value,
          tanggal: document.getElementById("tanggal").value,
          gambarUrl: document.getElementById("gambarUrl").value,
          gambarFile: document.getElementById("gambarFile").files[0],
        };
      },
    });

    if (!form) return;

    let finalImage = form.gambarUrl;
    if (form.gambarFile) {
      finalImage = await uploadToCloudinary(form.gambarFile);
    }

    await updateDoc(doc(db, "berita", item.id), {
      judul: form.judul,
      deskripsi: form.deskripsi,
      tanggal: form.tanggal || item.tanggal,
      gambar: finalImage || "",
    });

    Swal.fire("Berhasil!", "Berita diperbarui", "success");
    fetchData();
  };

  /* ================= HAPUS ================= */
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Hapus berita ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
    });

    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "berita", id));
    Swal.fire("Terhapus!", "Berita berhasil dihapus", "success");
    fetchData();
  };

  /* ================= UI ================= */
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Kelola Berita</h3>
        <button className="btn btn-primary" onClick={handleAdd}>
          + Tambah Berita
        </button>
      </div>

      <div className="row">
        {list.length === 0 ? (
          <p>Belum ada berita</p>
        ) : (
          list.map((b) => (
            <div key={b.id} className="col-md-4 mb-3">
              <div className="card shadow-sm h-100">
                {b.gambar && (
                  <img
                    src={b.gambar}
                    className="card-img-top"
                    style={{ height: 180, objectFit: "cover" }}
                    alt={b.judul}
                  />
                )}
                <div className="card-body">
                  <h5>{b.judul}</h5>
                  <p className="text-muted small">
                    {b.deskripsi?.substring(0, 100)}...
                  </p>
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-warning btn-sm me-1"
                      onClick={() => handleEdit(b)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(b.id)}
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
